export const AuthLayout = ({ title, subtitle, children, isLight, onToggleMode, modeText, modeAction }) => (
  <div className={`w-full rounded-lg p-8 md:p-12 border transition-all duration-500 animate-in shadow-2xl backdrop-blur-md ${
    isLight ? 'bg-white/80 border-slate-200' : 'bg-[#111114]/80 border-white/10'
  }`}>
    <div className="mb-10 text-center md:text-left">
      <h2 className={`text-2xl font-black italic tracking-tighter ${isLight ? 'text-slate-900' : 'text-white'}`}>
        {title}
      </h2>
      <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-slate-500 mt-1">
        {subtitle}
      </p>
    </div>

    {children}

    <div className="mt-8 pt-8 border-t border-white/5 text-center">
      <button 
        onClick={onToggleMode}
        className={`text-[10px] font-black uppercase tracking-[0.2em] transition-colors ${
          isLight ? 'text-slate-400 hover:text-slate-900' : 'text-slate-500 hover:text-white'
        }`}
      >
        {modeText} <span className="text-cyan-500 ml-1">{modeAction}</span>
      </button>
    </div>
  </div>
);